import {
  Flex,
  Button,
  FlexColumn,
  Breadcrumbs,
  SearchField,
} from '@elementary/common-ui/components';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';
import { ROLE_ID, NEW_VALUE } from '@elementary/common-ui/constants/urlParams';

interface HeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
}

const Header = ({ search, onSearchChange }: HeaderProps) => {
  const [, setSearchParams] = useSearchParams();

  return (
    <FlexColumn sx={{ gap: 3 }}>
      <Breadcrumbs items={['Account', 'Roles']} showTreeButton={false} />
      <Flex sx={{ gap: 1, justifyContent: 'space-between' }}>
        <SearchField
          sx={{ width: '248px' }}
          onChange={(e) => onSearchChange(e.target.value)}
          value={search}
        />
        <Button
          sx={{ minWidth: '142px' }}
          onClick={() =>
            setSearchParams((prev) => {
              prev.set(ROLE_ID, NEW_VALUE);
              return prev;
            })
          }
        >
          Create role
        </Button>
      </Flex>
    </FlexColumn>
  );
};

export default Header;
